import type {PosterTypeObject} from '@PosterWhiteboard/poster-type/poster-type.types';

export interface PosterTypeCategory {
  id: string | number;
  name: string;
  posterTypes: Array<PosterTypeObject>;
  sortOrder: number | string;
}

let posterTypesHashmap: Record<string, PosterTypeObject> = {};

export const getPosterTypes = async () => {
  if (Object.keys(posterTypesHashmap).length === 0) {
    const data = await window.PMW.readLocal('postertype/getPosterTypeCategories');
    posterTypesHashmap = getPosterTypesFromBackendData(data);
  }

  return posterTypesHashmap;
};

export const getPosterTypesCategorized = async (): Promise<Array<PosterTypeCategory>> => {
  return (await window.PMW.readLocal('postertype/getPosterTypeCategories')) as Array<PosterTypeCategory>;
};

export const addCustomUserSize = async (width: number, height: number, units: string, sizeName: string): Promise<PosterTypeObject> => {
  return (await window.PMW.readLocal('postertype/addNewUserPosterType', {
    w: width,
    h: height,
    u: units,
    sn: sizeName,
  })) as PosterTypeObject;
};

export const deleteUserPosterTypeForID = async (idUserPosterType: number): Promise<void> => {
  return (await window.PMW.readLocal('postertype/deleteUserPosterType', {
    id: idUserPosterType,
  })) as void;
};

const getPosterTypesFromBackendData = (data: any) => {
  const posterTypes: Record<string, PosterTypeObject> = {};
  for (const category of data) {
    if (category.name != 'Popular') {
      for (const posterType of category.posterTypes) {
        posterTypes[posterType.name] = posterType;
      }
    }
  }
  return posterTypes;
};

export interface UploadMediaIntroPopupSeenResponse {
  hasSeen: number;
}